module.exports = __webpack_public_path__ + "static/media/nitro.0abb1445.png";